import { setError } from '../helpers/custom';

export const Rules = {
  /*
    dgToLow({ amountDG }) {
      if (amountDG < 15000) {
        return setError('Vous n\'êtes pas éligible pour un dépôt de garantie inférieur à 15 000 €');
      }
    },
    fieldAreNotFilled(n, document) {
      if (Object.keys(document).length < n) {
        return setError('Vous devez renseigner tous les champs.')
      }
    },
    invalidSIREN({ companySIREN = '0' }) {
      if (companySIREN.length < 9) {
        return setError('Numéro SIREN invalide');
      }
    },
    badSeniority({ seniority }) {
      if (seniority !== 'moreThan2Year') {
        return setError('Vous n\'êtes pas éligible pour une ancienneté de moins de 2 ans');
      }
    },
    */
  noIdentity({ name, phone, company }) {
    if (!name || !phone || !company) {
      return setError('Informations manquantes.');
    }
  },
  validEmail({ email = ''}) {
    if(!ValidateEmail(email)) {
      return setError('Adresse email non valide.');
    }
  },
  };


  export const rulesPerPage = [
    [Rules.noIdentity, Rules.validEmail],
    [],
    []
  ];


  export const validate = (rules, document, callback) => {
    let error = null;
    rules.some((rule) => {
      const o = rule(document) || {};
      if (o.error) error = o;
      return o.error;
    });
    if (error) {
      callback(error.detail);
      console.log(error.detail);
    }
    return !error?.error;
  }


function ValidateEmail(email) {
  if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
    return true;
  }
  return false;
}